// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"DescBlock_scroll-black__EtRdg","info-section-container":"DescBlock_info-section-container__O2i5H"};